<template>
    <div style="background-color: white;box-sizing:unset;min-width:1600px">
        <headers></headers>
        <!-- 中间内容区域开始 -->
         <!-- 中文版 -->
        <div v-if="langluageType != 'en'" class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articleguest.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/guest_logo.svg" class="banner_text_img">
                    <h1>面向各行业协会和主承办机构</h1>
                    <p>展会观众管理全流程一体化实时在线云管理系统</p>
                    <ul class="banner_ul">
                        <li data-type="Guest观众云" data-href="/spectator/user/login" id="ljsy"><a href="javascript:;">立&nbsp;即&nbsp;试&nbsp;用</a></li>
                    </ul>
                </div>
            </div>
            <div class="article">
                <div class="tit_con">
                    <h1>观众云的解决方案</h1>
                    <p>解决传统模式中，注册登记时间长、人员接触频次高、观众信息质量低、现场资源浪费大、观众登陆体验差、会后数据管理难等问题</p>
                </div>
                <div class="article_con clearfix">
                    <div class="article_con_module">
                        <h2>提高业务敏捷性</h2>
                        <ul>
                            <li><i class="square"></i>行业特定的功能和卓越实践</li>
                            <li><i class="square"></i>基于市场化专业展会积累的流程</li>
                            <li><i class="square"></i>实时嵌入式BI统计分析</li>
                            <li><i class="square"></i>覆盖观众注册全过程的自动化流程</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>获得稳定性和控制力</h2>
                        <ul>
                            <li><i class="square"></i>腾讯云部署确保数据安全</li>
                            <li><i class="square"></i>集成的商业智能快速把握新机遇</li>
                            <li><i class="square"></i>项目创建、票证设置，简化流程</li>
                            <li><i class="square"></i>注册即用，部署速度快</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>持续降本可持续性</h2>
                        <ul>
                            <li><i class="square"></i>自主注册、在线票证、信息同步灵活</li>
                            <li><i class="square"></i>票证管理、信息分类、内部沟通敏捷性高</li>
                            <li><i class="square"></i>实时管控、现场核销管理高效</li>
                            <li><i class="square"></i>支持实时分析，帮助提高利润和效率</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 英文版 -->
        <div v-else class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articleguest1.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/guest_logo.svg" class="banner_text_img">
                    <h1>Online visitor registration management system</h1>
                    <!-- <p style="line-height: normal;margin-top: 18px;margin-bottom: 18px;font-weight: 400;">Exhibition visitor management full process integrated real-time <br/> online cloud management system</p>
                    <ul class="banner_ul">
                        <li data-type="Guest观众云" data-href="/spectator/user/login" id="ljsy"><a href="javascript:;">Try it now</a></li>
                    </ul> -->
                </div>
            </div>
            <div class="article" style="width: 1600px;margin-top:70px;margin-bottom: 140px;">
                <!-- <div class="tit_con">
                    <h1>Guest Cloud Solutions</h1>
                    <p>Solve the problems in the traditional model, such as long registration time, high frequency of personnel contact, low quality of audience information, large waste of on-site resources, poor audience login experience, and difficult post-conference data management.</p>
                </div> -->
                <div class="article_con clearfix">
                    <div class="article_con_module" style="width:32%">
                        <h2>Improve business agility</h2>
                        <ul>
                            <li><i class="square"></i>Industry-specific capabilities and best practices</li>
                            <li><i class="square"></i>Process based on the accumulation of market-oriented professional <br/><span style="margin-left: 18px;">exhibitions</span></li>
                            <li><i class="square"></i>Real-time embedded BI statistical analysis</li>
                            <li><i class="square"></i>Automated process covering the entire visitor registration process</li>
                        </ul>
                    </div>
                    <div class="article_con_module" style="width:32%">
                        <h2>Gain stability and control</h2>
                        <ul>
                            <li><i class="square"></i>Tencent Cloud deployment ensures data security</li>
                            <li><i class="square"></i>Integrated business intelligence to quickly seize new opportunities</li>
                            <li><i class="square"></i>Project creation, ticket setting, simplified process</li>
                            <li><i class="square"></i>Register and use, fast deployment</li>
                        </ul>
                    </div>
                    <div class="article_con_module" style="width:36%">
                        <h2>Continuous cost reduction and sustainability</h2>
                        <ul>
                            <li><i class="square"></i>Self-registration, online ticketing, flexible information synchronization</li>
                            <li><i class="square"></i>High agility in ticket management, information classification, and internal <br/><span style="margin-left: 18px;">communication</span></li>
                            <li><i class="square"></i>Real-time control and on-site write-off management are efficient</li>
                            <li><i class="square"></i>Supports real-time analysis to help improve profits and efficiency</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 中间内容区域结束 -->
        <footers></footers>
        <contact></contact>
        <dialog1 data-type="Guest观众云"></dialog1>
    </div>
</template>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';
  import contact from '@/components/contact';
  import dialog1 from '@/components/dialog';

export default {
    components: {
      headers,
      footers,
      contact,
      dialog1
    },
    data(){
        return {
            langluageType:sessionStorage.getItem('langluageType')||'ch'
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/articleguest.vue